// ============================================================================
// kezdolap.js — a TAGOK KEZDŐLAPJÁNAK logikája (2026-10-25, a titkár #86 / #92 javaslata). Tiszta, DOM nélküli modul (tesztelhető).
//
// SZABÁLY: ha a tag legalább 1 órája (TAVOL_HATAR_MS) nem volt aktív ezen az eszközön - akár kijelentkezett, akár egyszerűen bezárta a
// böngészőt -, vagy ez az első belépése, a belépés után a KEZDŐLAP nyílik (a fontos közlemények és a kijelölt tájékoztató szobák);
// rövidebb szünet után a legutóbbi hely áll vissza (ahogy eddig). A kezdőlapról a "Visszatérés az előzőleg megtekintett helyre" gomb
// ugyanoda visz. Az "utolsó aktivitás" ideje ESZKÖZÖNKÉNT külön van (localStorage), ezért egy másik eszközön történő kijelentkezés nem
// változtatja meg ennek az eszköznek a célhelyét. Az idő az eszköz órájáról jön (a szerveridő-lekérés hálózatfüggő és itt nem kell).
// ============================================================================

/** A kivonat szövege a néző nyelvén: a kész fordítás, ha van (és nem a forrásnyelve a néző nyelve); különben az eredeti. (v163: a lista kevert nyelvű, olvashatatlan volt.) */
export function kivonatSzoveg(m, nezoNyelv) {
  const eredeti = typeof m.text === "string" ? m.text : "";
  if (!nezoNyelv || m.noTranslate === true || m.sourceLang === nezoNyelv) return eredeti;
  const f = m.translations && typeof m.translations === "object" ? m.translations[nezoNyelv] : null;
  return typeof f === "string" && f.trim() !== "" ? f : eredeti;
}

export const TAVOL_HATAR_MS = 60 * 60 * 1000;
export const AKTIV_ELOTAG = "l0_utolsoAktiv_";
export const KEZDOLAP_ELOZMENY_KULCS = "l0_kezdolapKiertekelve"; // sessionStorage: a lap újratöltése nem értékeli ki újra

const jo = (x) => typeof x === "string" && x.length > 0 && x.length < 200;

/** Az utolsó aktivitás rögzítése (ms). Sosem dob. */
export function aktivMentese(tar, uid, most = Date.now()) {
  if (!tar || !jo(uid)) return false;
  try {
    tar.setItem(`${AKTIV_ELOTAG}${uid}`, String(Math.floor(most)));
    return true;
  } catch (e) {
    return false;
  }
}

/** @returns {number|null} az utolsó aktivitás ideje (ms), vagy null, ha nincs / sérült */
export function aktivBetoltese(tar, uid) {
  if (!tar || !jo(uid)) return null;
  try {
    const n = Number(tar.getItem(`${AKTIV_ELOTAG}${uid}`));
    return Number.isFinite(n) && n > 0 ? n : null;
  } catch (e) {
    return null;
  }
}

/**
 * Kell-e a kezdőlap ennél a belépésnél? Igen, ha nincs korábbi aktivitás (első belépés / törölt adat), ha a szünet legalább egy óra,
 * vagy ha az óra "visszaugrott" (a jövőbeli időpont nem megbízható). 3599 mp = még nem, 3600 mp = már igen.
 */
export function kezdolapKell(utolsoAktiv, most = Date.now()) {
  if (!Number.isFinite(utolsoAktiv) || utolsoAktiv === null) return true;
  const eltelt = most - utolsoAktiv;
  return eltelt < 0 || eltelt >= TAVOL_HATAR_MS;
}

/**
 * A kezdőlap szoba-gombjai: a beállított (config/home) sorrendben, de CSAK azok a szobák, amelyek a tag saját szobalistájában vannak
 * (a kezdőlap nem tesz láthatóvá olyan szobát, amelyhez nincs hozzáférése); az archivált és a törlés alatti kimarad.
 * @returns {Array<object>} szobák
 */
export function kezdolapSzobak(roomIds, szobak) {
  const lista = Array.isArray(szobak) ? szobak : [];
  const ki = [];
  for (const id of Array.isArray(roomIds) ? roomIds : []) {
    const r = lista.find((x) => x && x.roomId === id && !x.archived && !x.deleting);
    if (r && !ki.includes(r)) ki.push(r);
  }
  return ki;
}
